"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isQywx = void 0;
// 是否企业微信
const isQywx = () => {
  return window.navigator.userAgent.toLowerCase().includes('wxwork');
};
exports.isQywx = isQywx;